/* =====================================================================
   KokkoPris — Judge.me: skjul anmeldelses-listen når skjemaet er åpent
   (man skal ikke se andres anmeldelser mens man skriver sin egen).
   Setter klassen .kp-writing på ALLE .jdgm-rev-widg når et review-skjema
   er synlig; CSS (section-footer.css) skjuler lista + paginering da.
   ===================================================================== */
(function () {
  // Er et review-skjema synlig på siden?
  function anyFormOpen() {
    var sel = [
      '.jdgm-form-wrapper form',
      '.jdgm-form-dynamic',
      '.jdgm-rev-widg form',
      '.jdgm-rev-widg input[type="email"]',
      '.jdgm-form input[type="email"]'
    ].join(',');
    var els = document.querySelectorAll(sel);
    for (var i = 0; i < els.length; i++) {
      var e = els[i];
      if (e.offsetParent !== null && e.getBoundingClientRect().height > 20) return true;
    }
    return false;
  }

  function update() {
    var open = anyFormOpen();
    document.querySelectorAll('.jdgm-rev-widg').forEach(function (w) {
      w.classList.toggle('kp-writing', open);
    });
  }

  // reager på klikk (åpne/avbryt) + flere oppdateringer pga. async-lasting
  document.addEventListener('click', function (e) {
    if (e.target.closest('.jdgm-write-rev-link, .jdgm-form-close-rev-btn, [class*="write-rev"], [class*="cancel"]')) {
      [60, 250, 600, 1200, 2200].forEach(function (d) { setTimeout(update, d); });
    }
  });

  // Hindre at siden hopper ved sidebytte: blokker PROGRAMMATISK scroll en kort
  // stund etter klikket, slik at Judge.me sin auto-scroll ikke skjer i det hele
  // tatt. Manuell scrolling (musehjul/scrollbar) påvirkes ikke. Da blir siden
  // bare stående der den er — ingen hopp, ingen retur.
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.jdgm-paginate__page, .jdgm-paginate__next-page, .jdgm-paginate__prev-page, .jdgm-paginate__last-page, .jdgm-paginate__first-page, .jdgm-paginate a')) return;
    var origTo = window.scrollTo, origScroll = window.scroll, origBy = window.scrollBy;
    var origSIV = Element.prototype.scrollIntoView;
    var noop = function () {};
    try {
      window.scrollTo = noop; window.scroll = noop; window.scrollBy = noop;
      Element.prototype.scrollIntoView = noop;
    } catch (err) {}
    setTimeout(function () {
      try {
        window.scrollTo = origTo; window.scroll = origScroll; window.scrollBy = origBy;
        Element.prototype.scrollIntoView = origSIV;
      } catch (err) {}
    }, 1800);
  }, true);

  function init() {
    update();
    var obs = new MutationObserver(function () { update(); });
    obs.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class', 'hidden'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(init, 1000); });
  } else {
    setTimeout(init, 1000);
  }
})();
